// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Tabs__wrapper___1Gffo","isLight":"Tabs__isLight___dtdp1","isActive":"Tabs__isActive___3TadX","batch":"Tabs__batch___3x1-X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/Tabs/Tabs.scss
// module id = 643
// module chunks = 0